/**
 *
 * Asynchronously loads the component for UserRegistration
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UserManagementModule = lazyLoad(
  () => import('./index'),
  module => module.UserManagementModule,
);
